import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SensitiveRevealState {
  /** When true, the workflow/delivery-run inspector shows values unmasked. */
  revealSensitive: boolean;
}

interface SensitiveRevealActions {
  setRevealSensitive: (reveal: boolean) => void;
}

/**
 * "Reveal sensitive data" switch for the Temporal-style run inspector.
 * Persisted to **sessionStorage**: the choice survives navigation and reloads
 * within the tab, but every new session starts masked again — the default the
 * inspector's obfuscation exists for.
 */
export const useSensitiveRevealStore = create<SensitiveRevealState & SensitiveRevealActions>()(
  persist(
    (set) => ({
      revealSensitive: false,
      setRevealSensitive: (reveal) => {
        set({ revealSensitive: reveal });
      },
    }),
    {
      name: 'inspector-reveal-sensitive',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
